export default __webpack_public_path__ + "static/media/Redfang.8c5ecb52.jpg";